import { render, staticRenderFns } from "./ColorModuleResult.vue?vue&type=template&id=3c906b21&scoped=true"
import script from "./ColorModuleResult.vue?vue&type=script&lang=ts"
export * from "./ColorModuleResult.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleResult.vue?vue&type=style&index=0&id=3c906b21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c906b21",
  null
  
)

export default component.exports